var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSchdule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9913_29472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 80.2441V24.2441H84.75V80.2441C84.75 82.4441 82.95 84.2441 80.75 84.2441H16.75C14.55 84.2441 12.75 82.4441 12.75 80.2441Z",
    fill: "url(#paint0_linear_9913_29472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75 16.2441V28.2441H12.75V16.2441C12.75 14.0441 14.55 12.2441 16.75 12.2441H80.75C82.95 12.2441 84.75 14.0441 84.75 16.2441Z",
    fill: "url(#paint1_linear_9913_29472)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M71.75 25.2441C68.436 25.2441 65.75 22.5581 65.75 19.2441V12.2441H77.75V19.2441C77.75 22.5581 75.064 25.2441 71.75 25.2441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M71.75 23.7441C69.264 23.7441 67.25 21.7301 67.25 19.2441V12.2441H76.25V19.2441C76.25 21.7301 74.236 23.7441 71.75 23.7441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M25.75 25.2441C22.436 25.2441 19.75 22.5581 19.75 19.2441V12.2441H31.75V19.2441C31.75 22.5581 29.064 25.2441 25.75 25.2441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M25.75 23.7441C23.264 23.7441 21.25 21.7301 21.25 19.2441V12.2441H30.25V19.2441C30.25 21.7301 28.236 23.7441 25.75 23.7441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 22.2441C24.094 22.2441 22.75 20.9001 22.75 19.2441V11.2441C22.75 9.58814 24.094 8.24414 25.75 8.24414C27.406 8.24414 28.75 9.58814 28.75 11.2441V19.2441C28.75 20.9001 27.406 22.2441 25.75 22.2441Z",
    fill: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75 39.2441V45.2441C76.75 45.7961 76.302 46.2441 75.75 46.2441H69.75C69.198 46.2441 68.75 45.7961 68.75 45.2441V39.2441C68.75 38.6921 69.198 38.2441 69.75 38.2441H75.75C76.302 38.2441 76.75 38.6921 76.75 39.2441ZM60.75 39.2441V45.2441C60.75 45.7961 60.302 46.2441 59.75 46.2441H53.75C53.198 46.2441 52.75 45.7961 52.75 45.2441V39.2441C52.75 38.6921 53.198 38.2441 53.75 38.2441H59.75C60.302 38.2441 60.75 38.6921 60.75 39.2441ZM44.75 39.2441V45.2441C44.75 45.7961 44.302 46.2441 43.75 46.2441H37.75C37.198 46.2441 36.75 45.7961 36.75 45.2441V39.2441C36.75 38.6921 37.198 38.2441 37.75 38.2441H43.75C44.302 38.2441 44.75 38.6921 44.75 39.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75 53.2441V59.2441C76.75 59.7961 76.302 60.2441 75.75 60.2441H69.75C69.198 60.2441 68.75 59.7961 68.75 59.2441V53.2441C68.75 52.6921 69.198 52.2441 69.75 52.2441H75.75C76.302 52.2441 76.75 52.6921 76.75 53.2441ZM60.75 53.2441V59.2441C60.75 59.7961 60.302 60.2441 59.75 60.2441H53.75C53.198 60.2441 52.75 59.7961 52.75 59.2441V53.2441C52.75 52.6921 53.198 52.2441 53.75 52.2441H59.75C60.302 52.2441 60.75 52.6921 60.75 53.2441ZM44.75 53.2441V59.2441C44.75 59.7961 44.302 60.2441 43.75 60.2441H37.75C37.198 60.2441 36.75 59.7961 36.75 59.2441V53.2441C36.75 52.6921 37.198 52.2441 37.75 52.2441H43.75C44.302 52.2441 44.75 52.6921 44.75 53.2441ZM28.75 53.2441V59.2441C28.75 59.7961 28.302 60.2441 27.75 60.2441H21.75C21.198 60.2441 20.75 59.7961 20.75 59.2441V53.2441C20.75 52.6921 21.198 52.2441 21.75 52.2441H27.75C28.302 52.2441 28.75 52.6921 28.75 53.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.75 67.2441V73.2441C60.75 73.7961 60.302 74.2441 59.75 74.2441H53.75C53.198 74.2441 52.75 73.7961 52.75 73.2441V67.2441C52.75 66.6921 53.198 66.2441 53.75 66.2441H59.75C60.302 66.2441 60.75 66.6921 60.75 67.2441ZM44.75 67.2441V73.2441C44.75 73.7961 44.302 74.2441 43.75 74.2441H37.75C37.198 74.2441 36.75 73.7961 36.75 73.2441V67.2441C36.75 66.6921 37.198 66.2441 37.75 66.2441H43.75C44.302 66.2441 44.75 66.6921 44.75 67.2441ZM28.75 67.2441V73.2441C28.75 73.7961 28.302 74.2441 27.75 74.2441H21.75C21.198 74.2441 20.75 73.7961 20.75 73.2441V67.2441C20.75 66.6921 21.198 66.2441 21.75 66.2441H27.75C28.302 66.2441 28.75 66.6921 28.75 67.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 22.2441C70.094 22.2441 68.75 20.9001 68.75 19.2441V11.2441C68.75 9.58814 70.094 8.24414 71.75 8.24414C73.406 8.24414 74.75 9.58814 74.75 11.2441V19.2441C74.75 20.9001 73.406 22.2441 71.75 22.2441Z",
    fill: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75 52.2441C63.496 52.2441 52.75 62.9901 52.75 76.2441C52.75 79.0541 53.258 81.7381 54.144 84.2441H80.75C82.95 84.2441 84.75 82.4441 84.75 80.2441V53.6381C82.244 52.7521 79.56 52.2441 76.75 52.2441Z",
    fill: "url(#paint2_radial_9913_29472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75 96.2441C87.7957 96.2441 96.75 87.2898 96.75 76.2441C96.75 65.1984 87.7957 56.2441 76.75 56.2441C65.7043 56.2441 56.75 65.1984 56.75 76.2441C56.75 87.2898 65.7043 96.2441 76.75 96.2441Z",
    fill: "url(#paint3_linear_9913_29472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.75 86.2441H75.75C75.198 86.2441 74.75 85.7961 74.75 85.2441V67.2441C74.75 66.6921 75.198 66.2441 75.75 66.2441H77.75C78.302 66.2441 78.75 66.6921 78.75 67.2441V85.2441C78.75 85.7961 78.302 86.2441 77.75 86.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75 77.2441V75.2441C66.75 74.6921 67.198 74.2441 67.75 74.2441H85.75C86.302 74.2441 86.75 74.6921 86.75 75.2441V77.2441C86.75 77.7961 86.302 78.2441 85.75 78.2441H67.75C67.198 78.2441 66.75 77.7961 66.75 77.2441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9913_29472",
    x1: 13.578,
    y1: 27.5681,
    x2: 67.504,
    y2: 66.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047ED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9913_29472",
    x1: 13.59,
    y1: 13.4601,
    x2: 83.146,
    y2: 27.6041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9913_29472",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.792 76.3281) scale(23.514)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9913_29472",
    x1: 68.93,
    y1: 62.5821,
    x2: 88.804,
    y2: 97.3041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4223CF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9913_29472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.75 0.244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSchdule);
export default __webpack_public_path__ + "static/media/saveSchdule.73bc50f29af26d85011eac14cb4a1375.svg";
export { ForwardRef as ReactComponent };